// Device-scoped dashboard mode override.
//
// Some family members want the dashboard as a calendar only. Others
// want it as a pet log. Others want the classic full check-in view.
// This flag lives on the device (not the account, not the member row)
// so the same person on the family iPad can still see the full dashboard
// if they want to check in from there.
//
// Values: "full" | "calendar" | "pets" | null (null → defer to family-wide setting)
//
// Migration: earlier versions wrote a boolean `famfeel_device_calendar_only`.
// We read that on first access and upgrade it to the new string key.

const KEY = "famfeel_device_dashboard_mode";
const LEGACY_KEY = "famfeel_device_calendar_only";

export const getDeviceDashboardMode = () => {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "calendar" || v === "pets" || v === "full") return v;
    // Migrate legacy boolean once.
    if (localStorage.getItem(LEGACY_KEY) === "1") {
      localStorage.setItem(KEY, "calendar");
      localStorage.removeItem(LEGACY_KEY);
      return "calendar";
    }
    return null;
  } catch {
    return null;
  }
};

export const setDeviceDashboardMode = (mode) => {
  try {
    if (mode === "calendar" || mode === "pets" || mode === "full") {
      localStorage.setItem(KEY, mode);
    } else {
      localStorage.removeItem(KEY);
    }
    localStorage.removeItem(LEGACY_KEY);
    window.dispatchEvent(new CustomEvent("famfeel:device-dashboard-mode-changed"));
  } catch {
    /* noop */
  }
};

// Legacy alias — kept for any old imports. Always reflects the new key.
export const isDeviceCalendarOnly = () => getDeviceDashboardMode() === "calendar";
export const setDeviceCalendarOnly = (on) =>
  setDeviceDashboardMode(on ? "calendar" : null);
